import LangEnum from '../../../../lang/LangEnum';
import { ActionEnum } from '../../../orders/actions/types/orderActions.types';
import {
  getValidContract,
  hasCurrentUserSigned,
  hasManualContracts,
  isAutoSignEnabled,
  isContractFullySigned,
  isCurrentUserRequiredToSign,
} from '../../contract/selectors/signedContracts/signedContracts.selectors';
import { FinishFlowHandler } from '../finishFlowHandler.types';
import { FinishFlowHandlerId } from '../finishFlowHandlerId.enum';

const SIGNATURE_REQUIRED_CODES = [
  LangEnum.ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_RULE,
  LangEnum.ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_AND_BRAND_RULE,
];

const contractSigningFlowHandler: FinishFlowHandler = {
  id: FinishFlowHandlerId.CONTRACT_SIGNING,

  getButtonOverride: ({ order, settings, conditionErrors, isBrand, translate }) => {
    const signatureError =
      conditionErrors.length &&
      conditionErrors.every((error) =>
        SIGNATURE_REQUIRED_CODES.some((langEnum) => translate(langEnum) === error),
      );

    if (
      !signatureError ||
      !isAutoSignEnabled(settings) ||
      hasManualContracts({ signedContracts: order.signedContracts })
    ) {
      return null;
    }

    if (!order.signedContracts.length) {
      return { isDisabled: false, clickAction: ActionEnum.OPEN_SIGN_ORDER_MODAL };
    }

    const contract = getValidContract({ signedContracts: order.signedContracts });

    if (!contract || isContractFullySigned({ contract })) {
      return null;
    }

    const isCurrentUserWaiting =
      hasCurrentUserSigned({ isBrand, contract }) ||
      !isCurrentUserRequiredToSign({
        isBrand,
        setting: settings.orderContractSignatureRequired,
      });

    return {
      label: isCurrentUserWaiting ? LangEnum.GLOBAL_AWAITING_SIGNATURE : LangEnum.GLOBAL_SIGN_ORDER,
      isDisabled: isCurrentUserWaiting,
      clickAction: ActionEnum.OPEN_CONTRACT_MODAL,
    };
  },
};

export default contractSigningFlowHandler;
